import React from "react";
import HeroImage from "../assets/myimage.jpeg";
import { FaFacebookF, FaGithub, FaLinkedin ,FaTwitter } from "react-icons/fa";
import { HiOutlineMail } from "react-icons/hi";


const Contact = () => {

    const profileImage = HeroImage;
    // These are for social links
    const links = [
        {
            id: 1,
            child: (
                <>
                    <FaLinkedin size={30} />
                </>
            ),
            href: "https://linkedin.com/in/mainuddin228",
            style: "bg-blue-600"
        },
        {
            id: 2,
            child: (
                <>
                    <FaGithub size={30} />
                </>
            ),
            href: "https://github.com/molla-mainuddin",
            style: "bg-gray-700"
        },
        {
            id: 3,
            child: (
                <>
                    <FaFacebookF size={30} />
                </>
            ),
            href: "https://facebook.com/mainuddin228",
            style: "bg-blue-600"
        },
        {
            id: 4,
            child: (
                <>
                    <HiOutlineMail size={30} />
                </>
            ),
            href: "mailto:mainuddin.molla1999@gmail.com",
            style: "bg-red-500"
        },
        {
            id: 5,
            child: (
                <>
                    <FaTwitter size={30} />
                </>
            ),
            href: "https://twitter.com/mainuddin228",
            style: "bg-blue-500"
        },
    ];

    return (
        <div
            name="contact"
            className="w-full h-auto bg-gradient-to-b from-black to-gray-800 p-4 text-white"
        >
            <div className="flex flex-col p-4 justify-center max-w-screen-lg mx-auto h-full">
                {/* This is for Contact Heading  */}
                <div className="pb-0 md:pb-5">
                    <p className="text-3xl md:text-4xl font-bold inline border-b-4 border-gray-500">
                        Contact
                    </p>
                    {/* <p className="py-6 text-sm md:text-xl">Submit the form below to get in touch with me</p> */}
                    <p className="py-6 text-base md:text-xl">Discuss a project or just want to say Hi? My inbox is open for all .</p>
                </div>
                {/* Total contact div */}
                <div className="flex flex-col md:flex-row justify-center">
                    {/* image and links div */}
                    <div data-aos="fade-right" className="flex flex-col w-full md:w-1/2">
                        <div className="">
                            <img
                                src={profileImage}
                                alt="my profile"
                                // className="rounded-2xl mx-auto w-2/3 md:w-full"
                                className="border-8 border-sky-500 mx-auto h-[95%] md:w-1/2 rounded-[50%]"
                            />
                        </div>
                        {/* for social l inks */}
                        <div className="p-6 flex flex-row justify-center space-x-2">
                            {links.map(({ id, child, href, style, download }) => (
                                <div
                                    key={id}
                                    className={`flex justify-between items-center p-2 rounded-full ${style}`}
                                >
                                    <a
                                        href={href}
                                        className="flex justify-between items-center w-full text-white cursor-pointer"
                                        download={download}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        {child}
                                    </a>
                                </div>
                            ))}
                        </div>
                    </div>
                    {/* contact form div */}
                    <div data-aos="fade-left" className="md:px-4 py-4 w-full md:w-1/2 flex justify-center items-center">
                        <form
                            action="https://getform.io/f/eed0caa8-c6ad-4756-ba81-720f46d48d5d"
                            method="POST"
                            className="flex flex-col w-full"
                        >
                            <input
                                type="text"
                                name="name"
                                placeholder="Enter your name"
                                required
                                className="p-2 bg-transparent border-2 rounded-md text-white 
                                    focus:outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500"
                            />
                            <input
                                type="text"
                                name="email"
                                placeholder="Enter your email"
                                required
                                className="my-4 p-2 bg-transparent border-2 rounded-md text-white
                                    focus:outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500"
                            />
                            <textarea
                                name="message"
                                placeholder="Enter your message"
                                required
                                rows="5"
                                className="p-2 bg-transparent border-2 rounded-md text-white 
                                    focus:outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500
                                    resize-none"
                            ></textarea>

                            <button className="text-white bg-gradient-to-b from-cyan-500 to-blue-500 px-4 md:px-6 py-2 md:py-3 my-6 mx-auto flex items-center rounded-md hover:scale-110 duration-300">
                                Let's talk
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;